<template>
  <div>
      <div class="flex items-center justify-between mb-5 sm:mb-6">
        <h4 class="text-lg lg:text-xl font-semibold text-gray-800">{{ evidence_data.evidences.type.name }}</h4>
        <button @click="goToEditPage" type="button" class="inline-flex items-center p-0.5 border border-transparent rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
            </svg>
        </button>
      </div>
        <div class="mb-4 sm:mb-5">
            <div v-if="evidence_data.evidences.evidence_type_id == 3">
                <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                        Statement Date:
                    </dt>
                    <dd class="mt-1 text-sm font-medium text-gray-800">
                        {{ evidence_data.evidences.appraisal_date }}
                    </dd>
                </div>
            </div>
        </div>
        <div class="mb-4 sm:mb-5">
            <div class="sm:col-span-1" v-if="evidence_data.evidences.evidence_type_id == 3">
                <dt class="text-sm font-medium text-gray-500">
                Purchase price:
                </dt>
                <dd class="mt-1 text-sm font-medium text-gray-800">
                    <span class="inline-flex items-center rounded-l-md  bg-gray-50 text-gray-500 font-medium">$</span>{{evidence_data.evidences.purchase_price }}
                </dd>
            </div>
            <div class="sm:col-span-1" v-if="evidence_data.evidences.evidence_type_id == 4">
                    <dt class="text-sm font-medium text-gray-500">
                    Appraised value:
                </dt>
                <dd class="mt-1 text-sm font-medium text-gray-800">
                    <span class="inline-flex items-center rounded-l-md  bg-gray-50 text-gray-500 font-medium">$</span>{{evidence_data.evidences.appraised_value }}
                </dd>
            </div>
            <div class="sm:col-span-1" v-if="evidence_data.evidences.evidence_type_id == 5">
                <dt class="text-sm font-medium text-gray-500">
                    Cost/Value impact:
                </dt>
                <dd class="mt-1 text-sm font-medium text-gray-800">
                    <span class="inline-flex items-center rounded-l-md  bg-gray-50 text-gray-500 font-medium">$</span>{{evidence_data.evidences.cost_or_value_impact }}
                </dd>
            </div>
            <div class="sm:col-span-1" v-if="evidence_data.evidences.evidence_type_id != 3 && evidence_data.evidences.evidence_type_id != 4 && evidence_data.evidences.evidence_type_id != 5 ">
                    <dt class="text-sm font-medium text-gray-500">
                    Cost of repairs:
                </dt>

                <dd class="mt-1 text-sm font-medium text-gray-800">
                    <span class="inline-flex items-center rounded-l-md  bg-gray-50 text-gray-500 font-medium">$</span>{{evidence_data.evidences.cost_of_repairs }}
                </dd>
            </div>
        </div>
        <div class="mb-4 sm:mb-5">
            <div class="sm:col-span-1" v-if="evidence_data.evidences.type.id == 1 || evidence_data.evidences.type.id == 2 || evidence_data.evidences.type.id == 5">
                <dt class="text-sm font-medium text-gray-500">Description:</dt>
                <dd class="mt-1 text-sm font-medium text-gray-800">
                    {{ evidence_data.evidences.description}}
                </dd>
            </div>
        </div>

        <div class="mb-4 sm:mb-5">
            <!-- {{evidence_data.operator_message}} -->
            <div class="sm:col-span-1" v-if="evidence_data.operator_message">
                <dt class="text-sm font-medium text-gray-500"> Comment:</dt>
                <dd class="mt-1 text-sm font-medium text-gray-800 break-all">
                    {{ evidence_data.operator_message}}
                </dd>
            </div>
        </div>

</div>
</template>

<script>
import { siteUrl } from '../../config/base';
export default {

props :["evidence_data","protest_request_uid"],
  components: {

  },
  data() {
    return {
    };
  },
  created(){
  },
  computed:{

  },
  methods: {
      goToEditPage(){
           window.location.href =
               siteUrl+'/admin/protest-requests/'+this.protest_request_uid+'/evidences/upload';
      }

  }
};
</script>

<style scoped>
</style>
